import {useEffect, useState} from 'react';

import {createRecaptchaConfig} from '../constants/recaptcha';
import {remoteConfigService} from '../services/remoteConfig';

export const useRecaptchaConfig = () => {
  const [config, setConfig] = useState(() => createRecaptchaConfig());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadConfig = () => {
      try {
        const remoteConfig = remoteConfigService.getJSON('recaptcha_configs');
        setConfig(createRecaptchaConfig(remoteConfig));
      } catch (err) {
        console.warn(
          'Failed to load recaptcha config from Remote Config, using defaults:',
          err
        );
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();

    const unsubscribe = remoteConfigService.onConfigChange(loadConfig);
    return unsubscribe;
  }, []);

  return {config, loading, error};
};
